module.exports = __webpack_public_path__ + "7b99cec250a4022c1b1655ded12c6a3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/campbell_soup_2021_chart.png
// module id = 1642
// module chunks = 0